// 导出一个中间件函数，用于触发注销操作
export const authService = {
  triggerLogout: () => {
    console.error('AuthService 尚未初始化');
  },
};